import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import teampic from "../assets/images/teampic.jpg";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import logo from "../assets/images/logo.png";
import pgImage from "../assets/images/pgImage.png";
import {
  CheckCircle,
  Bell,
  Home,
  CreditCard,
  Users,
  Settings,
} from "lucide-react";
import apiClient from "../api/Apiservice";
import { useEffect, useState } from "react";

import BangaloreImg from "../assets/images/Bangalore.jpg";

import Chennaiimg from "../assets/images/Chennai.jpg";

import Puneimg from "../assets/images/Pune.jpg";

import HyderabadImg from "../assets/images/Hyderabad.jpg";
import { BASE_URL } from "../api/devprofile";
import HomeCard from "./HomeCard";
import Features from "./Features";
import Footer from "./Footer";

import { useSearchStore } from "../zustand/useSearchStore";
import { useNavigate } from "react-router-dom";
import SignupModal from "./Signup";
import ListProperty from "./ListProperty";
import Header from "./Header";

interface PropertyData {
  partnerId: string;
  propertyId: string;
  basic_details: {
    propertyname: string;
    city: string;
    emailAddress: string;
    contactNumber: string;
    houseArea: string;
    pincode: string;
    state: string;
    managername: string;
    location: {
      latitude: number;
      longitude: number;
    };
    locality: string;
  };
  additional_information: {
    images: string[];
    chargesStatus: boolean;
    occupancyType: string;
  };
  property_information: {
    pgType: string;
    gstStatus: boolean;
  };
  lowestRent: number;
  overallRating: string;
  totalReviews: number;
  totalBed: number;
  availableBed: number;
  share_type: string[];
}

const features = [
  {
    title: "Effortless PG Booking",
    description:
      "Book your ideal PG accommodation with ease. Explore available options, complete your booking online, and enjoy a hassle-free move-in experience.",
    icon: Home,
  },
  {
    title: "Safe and Secure Living",
    description:
      "Your safety is our priority. With mandatory eKYC verification for all tenants and owners, we ensure a secure environment where you can feel safe and at home.",
    icon: CheckCircle,
  },
  {
    title: "Simplified Rent Management",
    description:
      "Pay your rent online, view payment history, and track your dues effortlessly.",
    icon: CreditCard,
  },
  {
    title: "Flexible Accommodation Options",
    description:
      "Explore a variety of PG options that cater to different needs, from shared to single rooms, with flexible terms to suit your preferences.",
    icon: Settings,
  },
  {
    title: "Community Engagement",
    description:
      "Easily connect with your roommates and fellow PG residents, fostering a sense of community and enhancing your living experience.",
    icon: Users,
  },
  {
    title: "Stay Updated with Notifications",
    description:
      "Never miss an update! Get real-time notifications about rent payments, dues, and important announcements directly in the app.",
    icon: Bell,
  },
];

const cities = [
  { name: "Bengaluru", img: BangaloreImg },
  { name: "Pune", img: Puneimg },
  { name: "Chennai", img: Chennaiimg },
  { name: "Hyderabad", img: HyderabadImg },
];

const cities2 = [
  {
    id: 0,
    city: "Bengaluru",
    // imageUri: require("../assets/bengaluru.png"),
    new: false,
    lat: 12.97194,
    lng: 77.59369,
  },
  {
    id: 1,
    city: "Chennai",
    // imageUri: require("../assets/chennai.png"),
    new: false,
    lat: 13.08784,
    lng: 80.27847,
  },
  {
    id: 2,
    city: "Coimbatore",
    // imageUri: require("../assets/coimbatore.png"),
    new: false,
    lat: 10.8,
    lng: 77.09,
  },

  {
    id: 3,
    city: "Hyderabad",
    // imageUri: require("../assets/hyd.png"),
    new: false,
    lat: 17.38405,
    lng: 78.45636,
  },
  {
    id: 4,
    city: "Pune",
    // imageUri: require("../assets/pune.png"),
    new: false,
    lat: 18.51957,
    lng: 73.85535,
  },
];

const HomeScreen: React.FC = () => {
  const [selectedCity1, setSelectedCity1] = useState<string | null>(null);
  const [propertiesData, setPropertiesData] = useState<PropertyData[]>([]);

  const { selectedCity, setSelectedCity, setSearchLocality } = useSearchStore();
  const [isSignupOpen, setSignupOpen] = useState(false);
  const [isListOpen, setListOpen] = useState(false);

  const [localityInput, setLocalityInput] = useState("");
  const [permissionGrant, setPermissionGrant] = useState<boolean>(false);
  const navigate = useNavigate();


      let cty='Bengaluru'
  // const handleNavigation = () => {
  //   setLocalityInput(localityInput);
  //   console.log("IN HAND");
   
  //   navigate("/properties", {
  //     state: {
  //       selectedCity,
  //       locality: localityInput,
  //     },
  //   });
  // };
  const handleNavigation = async (cityName?: any,status?:any) => {
    setLocalityInput(localityInput);
    console.log(selectedCity, "<-------------------");
  
    navigate("/properties", {
      state: {
        selectedCity: status==='city' ? cityName : selectedCity || "Bengaluru",
        locality: localityInput,
      },
    });
  };
  

  const handleSearch = async () => {
    setLocalityInput(localityInput);
 

    navigate("/properties", {
      state: {
        selectedCity,
        locality: localityInput,
      },
    });
  };
  const handleClickopen = () => {
    setSignupOpen(true);
  };

  useEffect(() => {
    const fetchProperties = async () => {
      const requestBody = {
        filtering: {
          amenities: [], // ✅ Correct
          pgType: "", // ✅ Correct
          startDate: "2025-02-11 12:47:00", // Optional Check
          endDate: "2025-02-11 12:47:00", // Optional Check
          priceRange: {
            min: 0,
            max: 0,
          },
          selectedCity: selectedCity || "Bengaluru",
          sorting: "ratings_high_low",
          page_size: 10,
          page_number: 1,
        },
      };

      try {
        const { data, status } = await apiClient.post<PropertyData[]>(
          `${BASE_URL}/zoy_customer/allproperties`,
          requestBody
        );

        if (status === 200) {
          setPropertiesData(data);
        } else {
        }
      } catch (error) {
      }
    };

    fetchProperties();
  }, [selectedCity]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data, status } = await apiClient.get(
          `${BASE_URL}/zoy_customer/2c700941-6c2b-4cc3-918c-0e37a5fe2df9/get_city_selector`
        );
        setSelectedCity1(data.selected_city);
      } catch (error) {
      }
    };

    fetchData();
  }, []);
  const handleClick = () => {
    setListOpen(true);
  };

  const handlePropertyClick = (propertyId: string, propertiesData: any) => {
    // navigate(`/propertyDetails`); // Redirecting to Property Details Page
    const selectedProperty = propertiesData.find(
      (property:any) => property.propertyId === propertyId
    );

    if (selectedProperty) {
      navigate(`/propertyDetails`, { state: { selectedProperty } });
    } else {
      console.error("Property not found:", propertyId);
    }
  };
  return (
    <div className="w-full overflow-hidden">
   <Header/>
      <section
        className="relative flex flex-col items-center justify-center text-white text-center min-h-screen bg-no-repeat bg-cover bg-center"
        style={{ backgroundImage: `url(${teampic})` }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center px-6 mt-40">
          <h1 className="text-5xl font-semibold">
            Zoy - Beyond a Stay, it's Home{" "}
          </h1>
          <p className="text-lg mt-3">
            Your ideal Living Space for Comfort and Convenience
          </p>

          <div className="flex items-center bg-white shadow-lg rounded-full p-2 mt-24 w-full max-w-2xl">
            <select
              className="bg-transparent px-4 py-2 border-r text-gray-700 outline-none"
              value={selectedCity}
              onChange={(e) => {
                const newCity = e.target.value;
                setSelectedCity(newCity);
              }}
            >
              <option value="" disabled>
              Select City
              </option>
              {cities2.map((city) => (
                <option key={city.id} value={city.city}>
                  {" "}
                  {city.city}{" "}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Search With Locality"
              value={localityInput}
              onChange={(e) => {
                setLocalityInput(e.target.value);
              }}
              className="flex-1 px-4 py-2 outline-none text-gray-700"
            />
            <button
              className="bg-pink-500 text-white px-5 py-3 rounded-full hover:bg-pink-600"
              onClick={handleSearch}
              disabled={selectedCity === "selectCity"}
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          {/* Subtitle Below Search Bar */}
          {/* <h2 className="text-3xl font-semibold mt-6 max-w-3xl leading-tight">
            Your Ideal Living Space for Comfort, Convenience, and Productivity
          </h2> */}

          {/* Location Tag */}
          <div className="mt-4 bg-white px-4 py-1 rounded-full text-sm">
            <h3 className="text-black">{selectedCity}</h3>
          </div>
        </div>

        {/* Featured Listings */}
        {/* <h2 className="text-3xl font-semibold text-center">Your Ideal Living Space for Comfort, Convenience, and Productivity</h2> */}

        <div className="grid gap-10 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mt-6 mb-8 px-4 ml-10">
  {propertiesData?.slice(0, 3).map((property, index) => (
    <div
      key={property.propertyId || index}
      onClick={() => handlePropertyClick(property.propertyId,propertiesData)}
      className="border rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-transform duration-300 transform hover:scale-105 bg-white w-72 mx-auto"
    >
      <img
        src={pgImage}
        alt={property?.basic_details?.propertyname}
        className="w-full object-cover hover:opacity-90 transition-opacity duration-300"
      />
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-2xl font-semibold text-black">
            {property?.basic_details?.propertyname}
          </h3>
          <p className="text-lg font-bold text-yellow-500 px-1 py-1 rounded-xl">
            ⭐ {property?.overallRating || "N/A"}
          </p>
        </div>

        <div className="flex justify-between items-center mb-4">
          <p className="text-lg text-gray-600">
            {property?.basic_details.locality}
          </p>
          <p
            className={`text-sm font-medium px-3 py-1 rounded-xl w-fit shadow-md ${
              property?.property_information?.pgType === "Men"
                ? "bg-blue-100 text-blue-500"
                : property?.property_information?.pgType === "Women"
                ? "bg-pink-100 text-pink-500"
                : "bg-green-100 text-green-500"
            }`}
          >
            {property?.property_information?.pgType} PG
          </p>
        </div>

        <p className="text-xl font-semibold text-black">
          Starts from ₹{property?.lowestRent}/month
        </p>
      </div>
    </div>
  ))}

  <div className="text-center mt-36">
    <button
      onClick={handleNavigation}
      className="bg-pink-500 hover:bg-white hover:text-pink-500 text-white font-semibold py-2 px-6 rounded-lg shadow-lg transition-transform duration-300 transform hover:scale-105"
    >
      Show More
    </button>
  </div>
</div>

      </section>

      <section className="py-12 px-6 bg-gray-100 text-center">
        <h2 className="text-3xl font-semibold mb-8">Why Choose Zoy?</h2>
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 border rounded-2xl bg-white shadow hover:shadow-lg transition duration-300"
            >
              <feature.icon className="w-10 h-10 text-primary mx-auto mb-4" />
              <h3 className="font-semibold text-xl mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <HomeCard />

      {/* Location Section */}
      <section className="py-12 px-6 bg-gray-900 text-white text-center">
        <h2 className="text-3xl font-semibold">
          Where will your next home be?
        </h2>

        <h1 className="p-2">
          You can find safe, contemporary living in thriving city neighborhoods
        </h1>

        <div className="p-2">
          <button
            className="bg-pink-500 text-white text-sm px-6 py-2 rounded-lg mt-2 hover:bg-pink-600"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Find Your Home
          </button>
        </div>

        <div className="mt-8 grid gap-6 grid-cols-2 md:grid-cols-4">
          {cities.map((city, index) => (
            <div key={index} className="rounded-lg overflow-hidden"  onClick={() => handleNavigation(city.name,"city")}
          >
              <img
                src={city.img}
                alt={city.name}
                className="w-full h-[450px] object-cover hover:scale-105 transition-transform duration-300"
              />
              <p className="mt-2 text-lg font-semibold text-center">
                {city.name}
              </p>
            </div>
          ))}
        </div>
      </section>

      <Features />
      <Footer />
    </div>
  );
};

export default HomeScreen;

